import 'babel-polyfill'
import './utils/impLibs/ImpOther'
import './utils/impLibs/ImpCx'
import Getpost from './plugins/app/method/getpost'
import Public from './lib/Public'
import '../static/fonts/iconfont.css'
import 'v-contextmenu/dist/index.css'
import './style/common/variable.less'
// eslint-disable-next-line
import drag from './plugins/app/method/drag.js'  //拖拽模块
import x2js from 'x2js' //xml数据处理插件
import Vue from 'vue'
import App from './App'
import echarts from 'echarts'
import { initAuth } from './plugins/app/layout/auth.js'
import 'echarts/theme/macarons'
import TianDiApi from './lib/TianDiApi'
import Layout from '@/plugins/app/com/Layout'
import Region from '@/plugins/app/com/Region'
import ContextMenu from '@/plugins/app/com/ContextMenu'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.component('cx-layout', Layout)
Vue.component('cx-region', Region)
Vue.component('cx-contextmenu', ContextMenu)
// Vue.use(vContextMenu)

window.TianDiApi = new TianDiApi({proxy: 'TianDi'})

window.cx = require('./lib/CX.js').default

// html根节点设置字体大小，系统中使用rem，默认100px
// document.body.parentNode.style.cssText = `font-size: ${100 / window.innerWidth * 100}vw`
// document.body.style.cssText = 'font-size: 0.16rem'

// window.cx_ = require('../static/lib/cx')
window.post = Getpost

window.public = Public

window.loginKey = 'zbcxEncrypt'
Vue.prototype.$echarts = echarts

// eslint-disable-next-line
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上

const initApp = async() =>
{
  try
  {
    await initAuth()
    window.vm = new Vue({
      el: '#app',
      router: router,
      store: store,
      components: { App },
      template: '<App/>'
    })
  }
  catch (e)
  {
    console.error('初始化失败:', e)
  }
}
initApp()

// window.addEventListener('beforeunload', function(e)
// {
//   localStorage.clear()
// })




// WEBPACK FOOTER //
// ./src/main.js